import { APIResponse, ConfigurableAppQueryArgs, useAppQuery } from '@alluradirect/react';

export interface UnavailableDates {
  MIN_NIGHTS_DATES: [
    {
      [key: string]: number;
    },
  ];
  PROPERTY_ID: string;
  LAST_BOOKABLE_DATE: string;
  LAST_DATE_OF_RATES: string;
  UNAVAILABILITY_ARRIVAL: string[];
  UNAVAILABILITY_DEPARTURE: string[];
  CANNOT_ARRIVE: string[];
  CANNOT_DEPART: string[];
}

export const usePropertyUnavailableDates = (pid: number, rest: ConfigurableAppQueryArgs = {}) => {
  return useAppQuery<APIResponse<UnavailableDates>>({
    endpoint: `/RESTAUTH/property/unavailabledates/?id=${pid}`,
    ...rest,
  });
};
